import { gql } from "@grandvisionhq/graphql";
const PlaceByIdFragment = gql`
  fragment PlaceById on Place {
    coordinates {
      lat
      lon
    }
  }
`;
export {
  PlaceByIdFragment as default
};
//# sourceMappingURL=place-by-id.js.map
